module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/area_map-d59073c5ae62bb4fc26f7e088f30655c.png";